export enum EditDrillingHoleMode {
  NEW_DRILLING_HOLE_MODE,
  EDIT_DRILLING_HOLE_MODE,
  DRILLING_HOLE_WIZARD_MODE
}
